import * as i0 from "@angular/core";
var Messenger = /** @class */ (function () {
    function Messenger() {
        this.queue = [];
    }
    Messenger.prototype.registerListener = function (listener) {
        this.listener = listener;
        if (this.queue.length > 0) {
            var msg = void 0;
            while (msg = this.queue.shift()) {
                this.listener.apply(this, msg);
            }
        }
    };
    Messenger.prototype.send = function (message, isError) {
        if (this.listener) {
            this.listener(message, isError);
        }
        else {
            this.queue.push([message, isError]);
        }
    };
    Messenger.ngInjectableDef = i0.defineInjectable({ factory: function Messenger_Factory() { return new Messenger(); }, token: Messenger, providedIn: "root" });
    return Messenger;
}());
export { Messenger };
